{
  "dismiss": "Revocare"
}
